import {
    useMemo,
} from 'react'
import IconButton from '@mui/material/IconButton'
import useHasPermission from 'app/hooks/useHasPermission'
import useRatesRoutes from 'app/SkyNetRoutes/hooks/useRatesRoutes'
import {
    ReactComponent as BulkEditSvg,
} from 'app/shared-components/images/icons/bulk_edit.svg'
import SkyNetDataGrid from 'app/shared-components/SkyNetDataGrid'
import useDataGridSource from 'app/shared-components/SkyNetMasterDataGrid/hooks/useDataGridSource'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import useLabel from 'app/hooks/useLabel'
import requests from 'app/requests/APricingRateCard/APricingRateCard.requests'
import {
    PersistentKeys,
    registerPersistentKey,
} from 'app/enums/persistentKeys'
import {
    APricingRateCardResponse,
} from 'app/requests/APricingRateCard/APricingRateCard.types'
import {
    RateCardStatus,
} from 'app/enums/label.enums'
import defaultRateCardsSort from 'app/Apps/Rates/Rates.utils'

import columns from './standardAdditionalFees.columns'

const persistentKey = registerPersistentKey(PersistentKeys.ARateCardsAdditionalFeesTable)

const StandardAdditionalFees = ({
    data,
}: Readonly<{ data: APricingRateCardResponse }>) => {
    const l = useLabel()
    const {
        ARateCards: ARateCardsRoutes,
    } = useRatesRoutes()

    const updatePermission = useHasPermission(['a_pricing_rates_update'])
    const isEditable = data?.status === RateCardStatus.IN_PROGRESS

    const dataSource = useDataGridSource({
        request: requests.standardAdditionalFeeFilterRequest({
            rateCardId: data?.id,
        }),
        key: RequestKeys.getAPricingRateCardAdditionalFeeRequest,
        defaultSort: defaultRateCardsSort,
    })

    const toolbarControls = useMemo(() => {
        if (!isEditable || !updatePermission) {
            return []
        }
        return [(
            <IconButton
                data-testid="bulk-edit-btn"
                onClick={() => {
                    ARateCardsRoutes.BulkEdit.AdditionalFees.navigate({
                        params: {
                            key: data.id,
                        },
                    })
                }}
            >
                <BulkEditSvg />
            </IconButton>
        )]
    }, [
        ARateCardsRoutes.BulkEdit.AdditionalFees,
        data.id,
        isEditable,
        updatePermission,
    ])

    return (
        <SkyNetDataGrid
            persistentKey={persistentKey}
            customDataSource={dataSource}
            columns={columns}
            toolbarProps={{
                title: l('STANDARD_ADDITIONAL_FEES'),
                toolbarControls,
            }}
        />
    )
}

export default StandardAdditionalFees
